import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Navigate } from 'react-router'
import { CoachMark } from '../../coachMark'
import { coachMarkRoutes } from '../../coachMark/constants'
import useGetVAT from '../../common/category/useVAT'
import { Element } from '../../common/html/element'
import { Icon } from '../../common/html/icon'
import { Loading } from '../../common/loading'
import { ScrollComponent } from '../../common/scrollComponent'
import { selectUserType } from '../../layout/store/slice'
import { COMPONENTS } from '../../routers/constants'
import { selectNumberOfCompany } from '../../tool/screening/exportFileSetting/store/slice'
import { USER_TYPE } from '../../utils/authorization'
import {
  BANK_TRANSFER_TYPE,
  MIN_HEIGHT_CHECK_OUT,
  PAYMENT_METHOD,
  STEP,
  TYPE_TRANSFER,
} from '../constant'
import classes from '../index.module.scss'
import {
  changeCheckRules,
  selectCheckIds,
  selectCheckRules,
  selectLoading,
  selectTerms,
} from '../store/slice'
import {
  getTerms,
  getUserPricingPackages,
  getUserProfile,
} from '../store/thunk'
import ContentOrder from './ContentOrder'
import PaymentMethod from './components/PaymentMethod'
import { PlaceOrder } from './components/PlaceOrder'
import Price from './components/Price'
import { TermsAndCondition } from './components/TermsAndCondition'
import UserInformation from './components/UserInformation'
import { ContentOrderScreening } from './components/screening/ContentOrderScreening'

const OrderInformation = ({ setStep, isScreening }) => {
  const numberCompany = useSelector(selectNumberOfCompany)
  const idCheck = useSelector(selectCheckIds)
  const userType = useSelector(selectUserType)

  if ((!numberCompany && isScreening) || (!isScreening && !idCheck.length))
    return <></>

  if ([USER_TYPE.TRIAL].includes(userType.userTypeId)) {
    return <Navigate to={`${COMPONENTS.cartAndOrders.route}?step=1`} />
  }

  return (
    <Element
      style={{ backgroundColor: '#FFFFFF' }}
      className={`${classes.orderInformationContainer}`}
    >
      <ScrollComponent>
        <CoachMark id={coachMarkRoutes['/cartAndOrders/confirmation']}>
          <ContentInformation setStep={setStep} isScreening={isScreening} />
        </CoachMark>
      </ScrollComponent>
    </Element>
  )
}

export default OrderInformation

export const ContentInformation = ({ setStep, isScreening }) => {
  const dispatch = useDispatch()

  const { vatPercentage } = useGetVAT(true)
  const refInfo = useRef()

  const numberCompany = useSelector(selectNumberOfCompany)
  const idCheck = useSelector(selectCheckIds)
  const loadingUserProfile = useSelector(selectLoading('getUserProfile'))
  const loadingPricing = useSelector(selectLoading('getUserPricingPackages'))
  const loadingTerms = useSelector(selectLoading('getTerms'))
  const locale = useSelector((state) => state.i18n.locale)

  const [method, setMethod] = useState(PAYMENT_METHOD.BANK_TRANSFERS)
  const [bankTransferType, setBankTransferType] = useState(
    BANK_TRANSFER_TYPE.ONE_PAY_ONLINE,
  )
  const [isValid, setIsValid] = useState({
    customerName: true,
    companyName: true,
    companyAddress: true,
    taxCode: true,
    invoiceReceivingEmail: true,
    phone: true,
  })
  const [unitBank, setUnitBank] = useState(TYPE_TRANSFER.VND)
  const [height, setHeight] = useState(0)
  const [isShowInvalidPackage, setShowInvalidPackage] = useState(false)

  const backStep = () => {
    setStep(STEP.SHOPPING_CART)
  }

  useEffect(() => {
    if ((!numberCompany && isScreening) || (!isScreening && !idCheck.length)) {
      window.open(
        `${COMPONENTS.cartAndOrders.route}?step=${STEP.SHOPPING_CART}`,
        '_self',
      )
    }
    dispatch(getUserProfile())
    dispatch(
      getUserPricingPackages({
        GroupByReportType: true,
      }),
    )
  }, [])

  useEffect(() => {
    dispatch(getTerms())
  }, [locale])

  useEffect(() => {
    if (refInfo?.current) {
      setHeight(refInfo?.current?.clientHeight)
    }
  }, [loadingUserProfile, loadingPricing, loadingTerms])

  return (
    <>
      <div style={{ padding: '20px 24px 0px' }} className="h100 flexColumn">
        {loadingUserProfile || loadingPricing || loadingTerms ? (
          <Loading />
        ) : (
          <>
            <>
              {!isScreening && (
                <Element
                  style={{ border: '1px solid #D5D5D5' }}
                  className={`cursorPointer ${classes.buttonBack}`}
                  onClick={backStep}
                >
                  <div>
                    <Icon className="icon-arrow-left" style={{ fontSize: 8 }} />
                  </div>
                  <Translate value="cartAndOrders.orderInformation.backTo" />
                </Element>
              )}
              <Element style={{ fontSize: 20 }} className="mt1 fw500">
                <Translate value="cartAndOrders.orderInformation.summary" />
              </Element>
            </>
            <div className="dFlex justifyContentBetween flex1">
              <div className={classes.w530}>
                {isScreening ? (
                  <ContentOrderScreening />
                ) : (
                  <ContentOrder height={height} />
                )}
              </div>
              <Element
                style={{
                  backgroundColor: '#F3F3F3',
                  borderTop: '8px solid #FFFFFF',
                }}
                className={classes.w410}
                ref={refInfo}
              >
                <PaymentMethod
                  method={method}
                  setMethod={setMethod}
                  bankTransferType={bankTransferType}
                  setBankTransferType={setBankTransferType}
                  isScreening={isScreening}
                  unitBank={unitBank}
                  setUnitBank={setUnitBank}
                  isShowInvalidPackage={isShowInvalidPackage}
                />
                {method !== PAYMENT_METHOD.PACKAGE && (
                  <>
                    <Price
                      isScreening={isScreening}
                      vatPercentage={vatPercentage}
                    />
                    <UserInformation
                      method={method}
                      isValid={isValid}
                      setIsValid={setIsValid}
                    />
                    {method !== PAYMENT_METHOD.POST_PAID && (
                      <TermsAndCondition
                        changeCheckRules={changeCheckRules}
                        selectCheckRules={selectCheckRules}
                        selectTerms={selectTerms}
                        style={{ bottom: MIN_HEIGHT_CHECK_OUT }}
                      />
                    )}
                  </>
                )}
              </Element>
            </div>
            <Element
              className={classes.placeOrderContainer}
              style={{
                backgroundColor: '#FFFFFF',
                borderTop: '1px solid #D5D5D5',
                zIndex: 99,
              }}
            >
              <Element
                className="dFlex alignItemsCenter justifyContentBetween"
                style={{ height: MIN_HEIGHT_CHECK_OUT }}
              >
                <div>&nbsp;</div>
                <PlaceOrder
                  method={method}
                  bankTransferType={bankTransferType}
                  isValid={isValid}
                  setIsValid={setIsValid}
                  isScreening={isScreening}
                  unitBank={unitBank}
                  setShowInvalidPackage={setShowInvalidPackage}
                />
              </Element>
            </Element>
          </>
        )}
      </div>
    </>
  )
}
